import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import getUiComponent from '../create-editor/get-ui-component';
import { CoreEditor } from './core-editor';
export function ComposableEditor(props) {
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var AppearanceComponent = useMemo(function () {
    return getUiComponent(props.appearance);
  }, [props.appearance]);
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement(CoreEditor, _extends({}, props, {
    AppearanceComponent: AppearanceComponent
  }));
}